<template>
  <f7-app :params="f7params">
    <leftPanel
      v-if="canAccessApp"
      :elements="opcionesMenu"
      :version="version"
    />
    <FilterPanel v-if="canAccessApp" />
    <login v-if="loginNeeded && !requestNewPasssword" />
    <recoveryPassword
      v-if="loginNeeded && requestNewPasssword"
      :opened="requestNewPasssword"
    />
    <!-- TODO: Mostrar cuando queramos avisar al usuario que tenemos listados offline -->
    <!-- v-if="canAccessApp && !syncNeeded" -->
    <f7-view
      v-if="canAccessApp"
      main
      resizable
      class="safe-areas"
      url="/"
      :reload-pages="true"
      :dom-cache="false"
      :stack-pages="false"
    />
    <!-- TODO: Mostrar cuando queramos avisar al usuario que tenemos listados offline -->
    <!-- <SyncModal
      :opened="syncNeeded"
      :is-syncing="isSyncing"
      :sync-error="syncError"
      @syncRequested="completeDataBaseSync"
    /> -->
  </f7-app>
</template>
<script>

import { Device } from 'framework7/framework7-lite.esm.bundle';
import { mapActions, mapState, mapMutations } from 'vuex';
import { APP_VERSION, MILISECONDS_TO_REFRESH_AUTOMATICALLY_DAILY } from '../js/constants';
import cordovaApp from '../js/cordova-app';
import store from '../store/index';
import routes from '../js/routes';
import leftPanel from './LeftPanel.vue';
import opcionesMenu from '../json/menuList.json';
import login from '../pages/accounts/loginPage.vue';
import recoveryPassword from './accounts/RecoveryPassword.vue';
import FilterPanel from './FilterPanel/index.vue';
import sync from '../services/Sync'

export default {
  components: {
    leftPanel,
    login,
    recoveryPassword,
    FilterPanel,
  },
  store,
  data() {
    return {
      version: APP_VERSION,
      opcionesMenu,
      showToDefault: true,
      // Framework7 Parameters
      f7params: {
        id: 'es.hispatec.timac', // App bundle ID
        name: 'Timac', // App name
        theme: 'auto', // Automatic theme detection

        // App routes
        routes,
        // Input settings
        input: {
          scrollIntoViewOnFocus: Device.cordova && !Device.electron,
          scrollIntoViewCentered: Device.cordova && !Device.electron,
        },

        // Cordova Statusbar settings
        statusbar: {
          iosOverlaysWebView: true,
          androidOverlaysWebView: false,
          androidTextColor: 'white',
          androidBackgroundColor: '#000000',
          iosTextColor: 'white',
          iosBackgroundColor: '#000000',
        },
      },
      // Login screen data
      username: '',
      password: '',
    };
  },
  computed: {
    loginNeeded() {
      return this.loggedUser == null;
    },
    canAccessApp() {
      return this.loggedUser != null;
    },
    requestNewPasssword() {
      return (this.loggedUser == null && this.wantToRecoveryPass === true);
    },
    showMessage() {
      return this.messageChangePassword;
    },
    syncNeeded() {
      return this.loggedUser != null
        && this.lastSuccessfulSync == null;
    },
    ...mapState('authentication', [
      'activationCode',
      'loggedUser',
      'appConfig',
      'wantToRemember',
      'wantToRecoveryPass',
      'changePassword',
      'messageChangePassword',
      'user',
    ]),
    ...mapState('databaseSync', [
      'isSyncing',
      'lastSuccessfulSync',
      'syncError',
    ]),
  },
  async mounted() {
    this.$f7ready((f7) => {
      // Init cordova APIs (see cordova-app.js)
      if (Device.cordova) {
        cordovaApp.init(f7);
      }
      if (this.loggedUser) {
        const { user } = this.user;
        this.$fa.setUserId(user.email);
        this.$fa.setUserProperty("email", user.email);
        this.$fa.logEvent('login', {
          content_type: 'component',
          description: 'Evento de inicio de sesión'
        });
        this.setupAutoRefresh(); // LLamo al metodo para aplicar el temporizador para actualizar la base de datos
      }
    });
  },
  methods: {
    setupAutoRefresh() {
      setInterval(this.refreshDatabase, MILISECONDS_TO_REFRESH_AUTOMATICALLY_DAILY);
    },
    refreshDatabase() {
      sync.updateDataBaseRecords()
        .then(() => {
          // La actualización se ha completado
          console.log('Database refreshed successfully');
        })
        .catch((error) => {
          console.error('Error refreshing database:', error);
        });
    },

    closePopup() {
      this.setMessageChangePassword();
    },

    ...mapActions('authentication', ['activateApp', 'deactivateApp', 'logout']),
    ...mapActions('AccessControl', ['scan']),
    ...mapMutations('authentication', ['setMessageChangePassword']),
    ...mapActions('databaseSync', ['completeDataBaseSync']),
  },
};
</script>

<style lang="scss" scoped>
.panel {
  min-width: var(--f7-panel-left-collapsed-width);
}
</style>
